var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-showcase",style:({
    backgroundImage: _vm.backgroundImage
  })},[_c('div',{staticClass:"left-container"},[_vm._t("image",function(){return [(_vm.book)?_c('img',{staticClass:"showcase-image",attrs:{"src":_vm.book}}):_vm._e()]})],2),_c('div',{staticClass:"right-container"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("default"),(_vm.link)?_c('a',{staticClass:"showcase-cta",attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v("Learn More")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }